module.exports = __webpack_public_path__ + "img/fa.a47a1d16.svg";